import WorkflowRunHistoryPane from "ee/pages/Editor/WorkflowEditor/BottomBar/WorkflowRunHistory";
import { getShowRunHistoryPaneState } from "ee/selectors/workflowRunHistorySelectors";
import React from "react";
import { useSelector } from "react-redux";

export default function RunHistory() {
  // Run history render flag
  const paneVisible = useSelector(getShowRunHistoryPaneState);

  return paneVisible ? <WorkflowRunHistoryPane /> : null;
}
